<script>
  const logoUrl = "./img/logo.png";
  import { createEventDispatcher } from "svelte";

  const dispatchEvent = createEventDispatcher();
  function changePage(page) {
    dispatchEvent("changePage", page);
  }

  export let company_name = "Caribe Drinks";
  export let order_done;
  export let page_active;
</script>

<nav class="navbar navbar-expand-lg navbar-dark bg-primary mb-3">
  <a class="navbar-brand" href="/">
    <img src={logoUrl} style="height: 37px;" alt={company_name} />
  </a>
  <button
    class="navbar-toggler"
    type="button"
    data-toggle="collapse"
    data-target="#navbarColor01"
    aria-controls="navbarColor01"
    aria-expanded="false"
    aria-label="Toggle navigation">
    <span class="navbar-toggler-icon" />
  </button>
  {#if !order_done}
    <div class="collapse navbar-collapse" id="navbarColor01">
      <ul class="navbar-nav mr-auto">
        <li class="nav-item {page_active == 'products' ? 'active' : ''}">
          <a class="nav-link" on:click={() => changePage('products')} href="#">
            Produtos
            {#if page_active == 'products'}
              <span class="sr-only">(current)</span>
            {/if}
          </a>
        </li>
        <li class="nav-item {page_active == 'checkout' ? 'active' : ''}">
          <a class="nav-link" on:click={() => changePage('checkout')} href="#">
            Carrinho
            {#if page_active == 'checkout'}
              <span class="sr-only">(current)</span>
            {/if}
          </a>
        </li>
      </ul>
    </div>
  {/if}
</nav>
